import { FormSubmission, Form, AssessmentKeys } from '@uplift/types';
import { restClient } from '../../client';
import snakecaseKeys from 'snakecase-keys';

export type AssessmentSubmission = {
  score: number;
  score_diff_percentage?: number;
  submission: FormSubmission;
};

export type AssessmentSubmissionsOutput =
  | { error: string }
  | {
    submissions: AssessmentSubmission[];
  };

export type GetAllFormSubmissionsParams = {
  formKey: string;
  patientId: string;
  completedOnly?: boolean;
};
export const getAllFormSubmissions = (params: GetAllFormSubmissionsParams) =>
  restClient.request<AssessmentSubmissionsOutput>('/api/v1/form/submissions', {
    method: 'POST',
    data: snakecaseKeys(params),
  });


export const getBatchAssessmentSubmissions = (patientId: string, submissionIds: string[]) =>
  restClient.request<{ data: { submissions: AssessmentSubmission[]; forms: Form[]; form_id_to_key: {form_id: string; key: AssessmentKeys}[] } }>('/api/v1/form/batch-assessment-submission', {
    method: 'POST',
    data: {
      patient_id: patientId,
      submission_ids: submissionIds
    }
  });
